import { render, staticRenderFns } from "./catalogSwiper.vue?vue&type=template&id=5be2e781&scoped=true"
import script from "./catalogSwiper.vue?vue&type=script&lang=js"
export * from "./catalogSwiper.vue?vue&type=script&lang=js"
import style0 from "./catalogSwiper.vue?vue&type=style&index=0&id=5be2e781&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be2e781",
  null
  
)

export default component.exports